import { useEffect } from 'react'
import useBus from 'src/hooks/useBus'

export const UIKIT_BRIDGE_EVENT = 'uikit-bridge'

export const EVENT_TYPES = {
  SHOW_LOGIN_MODAL: 'show-login-modal',
} as const

export type EventType = (typeof EVENT_TYPES)[keyof typeof EVENT_TYPES]

/**
 * UIKitEventBridge - Bridges events between UIKit and legacy app
 *
 * This component listens for custom events emitted by UIKit components
 * and forwards them to the legacy event bus system.
 *
 * It should be included in the _app.js file to be available globally.
 */
const UIKitEventBridge = () => {
  const { send } = useBus()

  useEffect(() => {
    const handleUIKitEvent = (event: Event) => {
      const customEvent = event as CustomEvent
      const { type, payload } = customEvent.detail || { type: '', payload: undefined }

      switch (type as EventType) {
        case EVENT_TYPES.SHOW_LOGIN_MODAL:
          send(EVENT_TYPES.SHOW_LOGIN_MODAL, payload)
          break
        default:
          console.warn(`UIKitEventBridge: Unhandled event type: ${type}`)
      }
    }

    window.addEventListener(UIKIT_BRIDGE_EVENT, handleUIKitEvent)

    return () => {
      window.removeEventListener(UIKIT_BRIDGE_EVENT, handleUIKitEvent)
    }
  }, [send])

  return null
}

export default UIKitEventBridge
